import clsx from "clsx";
import React from "react";

export const NewContainer = (props) => {
  return (
    <div className={clsx(props.className, "xl:mx-20 xl:px-8")}>
      {props.children}
    </div>
  );
};
